import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const CACHE_RECOVERY_KEY = "pitaya-cache-recovery-once";

function getErrorMessage(errorLike) {
	return String(
		errorLike?.reason?.message ||
		errorLike?.message ||
		errorLike?.reason ||
		""
	);
}

function isRecoverableAssetError(errorLike) {
	const message = getErrorMessage(errorLike);

	return (
		message.includes("Loading chunk") ||
		message.includes("ChunkLoadError") ||
		message.includes("Failed to fetch dynamically imported module") ||
		message.includes("Importing a module script failed") ||
		message.includes("Unexpected token '<'") ||
		message.includes("Failed to fetch") ||
		message.includes("dynamically imported module")
	);
}

function reloadAppOnce() {
	try {
		const alreadyReloaded =
			window.sessionStorage.getItem(CACHE_RECOVERY_KEY) === "1";

		if (alreadyReloaded) return;

		window.sessionStorage.setItem(CACHE_RECOVERY_KEY, "1");
		window.location.reload();
	} catch (error) {
		window.location.reload();
	}
}

function clearRecoveryFlagOnSuccess() {
	try {
		window.sessionStorage.removeItem(CACHE_RECOVERY_KEY);
	} catch (error) {
		// sem problema se falhar
	}
}

async function unregisterAllServiceWorkers() {
	if (!("serviceWorker" in navigator)) return;

	try {
		const registrations = await navigator.serviceWorker.getRegistrations();
		await Promise.all(
			registrations.map((registration) => registration.unregister())
		);
	} catch (error) {
		console.warn("Erro ao remover service workers:", error);
	}
}

async function clearBrowserCaches() {
	if (!("caches" in window)) return;

	try {
		const cacheKeys = await window.caches.keys();
		await Promise.all(cacheKeys.map((key) => window.caches.delete(key)));
	} catch (error) {
		console.warn("Erro ao limpar caches do navegador:", error);
	}
}

function installGlobalRecoveryHandlers() {
	window.addEventListener("error", (event) => {
		if (isRecoverableAssetError(event)) {
			console.warn("Erro de asset/chunk detectado. Recarregando app...");
			reloadAppOnce();
		}
	});

	window.addEventListener("unhandledrejection", (event) => {
		if (isRecoverableAssetError(event)) {
			console.warn("Promise rejeitada por asset/chunk. Recarregando app...");
			reloadAppOnce();
		}
	});

	window.addEventListener("load", () => {
		clearRecoveryFlagOnSuccess();
	});
}

async function bootstrapApp() {
	installGlobalRecoveryHandlers();

	await unregisterAllServiceWorkers();
	await clearBrowserCaches();

	serviceWorkerRegistration.unregister();

	const rootElement = document.getElementById("root");
	const root = ReactDOM.createRoot(rootElement);

	root.render(
		<React.StrictMode>
			<Provider store={store}>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</Provider>
		</React.StrictMode>
	);
}

bootstrapApp();